import DiyOpenset from '../services/diy-openset';
const selectProduct = (productTile, select = true) => {
    const productImage = productTile.querySelector('meta[itemprop=image]');
    const productPrice = productTile.querySelector('meta[itemprop=price]');
    const productTileWrapper = productTile.closest('.openset-group');
    let index = 1;
    if (productTileWrapper) {
        index = productTileWrapper.dataset.group ? parseInt(productTileWrapper.dataset.group) + 1 : 1;
    }
    if (true == select && productImage && productPrice) {
        const productPriceVal = productPrice.getAttribute('content');
        let productImageUrl = productImage.getAttribute('content');
        if (!productImageUrl) {
            productImageUrl = '/img/ts.gif';
        }
        DiyOpenset.setProduct(index, {
            imageUrl: productImageUrl,
            price: productPriceVal ? parseFloat(productPriceVal) : 0,
        });
    }
    else if (false == select) {
        DiyOpenset.setProduct(index, null);
    }
};
const diyOpensetProductClickListener = () => {
    document
        .querySelectorAll('.openset-page .prod-tile .tile-select-box label input')
        .forEach((checkbox) => {
        checkbox.addEventListener('change', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const productTile = checkbox.closest('.prod-tile');
            if (productTile) {
                const productTileWrapper = productTile.parentElement;
                if (productTileWrapper) {
                    productTileWrapper.querySelectorAll('.prod-tile.checked').forEach((checkedProduct) => {
                        checkedProduct.classList.remove('checked');
                        const checkedProductCheckbox = checkedProduct.querySelector('.tile-select-box label input');
                        if (checkedProductCheckbox) {
                            checkedProductCheckbox.checked = false;
                        }
                    });
                }
                let selectedText = null;
                let unselectedText = null;
                if (checkbox.parentElement) {
                    selectedText = checkbox.parentElement.querySelector('.tile-select-box__selected-text');
                    unselectedText = checkbox.parentElement.querySelector('.tile-select-box__unselected-text');
                }
                if (selectedText && unselectedText) {
                    if (checkbox.checked) {
                        selectedText.style.display = 'inline';
                        unselectedText.style.display = 'none';
                    }
                    else {
                        selectedText.style.display = 'none';
                        unselectedText.style.display = 'inline';
                    }
                }
                if (checkbox.checked) {
                    productTile.classList.add('checked');
                    selectProduct(productTile);
                    if (DiyOpenset.activeTab !== null) {
                        if (DiyOpenset.activeTab + 1 < DiyOpenset.openset.details.productsNumber) {
                            DiyOpenset.showTab(DiyOpenset.activeTab + 1);
                        }
                    }
                }
                else {
                    productTile.classList.remove('checked');
                    selectProduct(productTile, false);
                }
            }
        });
    });
};
const diyOpensetAddToCartListener = () => {
    const addToCartButton = document.querySelector('.diy-offer__selection-price .add-to-cart');
    if (addToCartButton) {
        addToCartButton.addEventListener('click', () => {
            DiyOpenset.addToCart();
        });
    }
};
const diyOpensetSliderItemsListener = () => {
    document
        .querySelectorAll('.diy-offer__selection-slider .diy-offer__selection-product')
        .forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (item.dataset.index) {
                let index = parseInt(item.dataset.index);
                DiyOpenset.showTab(--index);
            }
        });
    });
};
export default (openset, selectionSlider) => {
    DiyOpenset.init(openset, selectionSlider);
    DiyOpenset.showTab(0);
    diyOpensetProductClickListener();
    diyOpensetSliderItemsListener();
    diyOpensetAddToCartListener();
    document.querySelectorAll('.openset-group__products').forEach((group) => {
        const selectedProduct = group.querySelector('.prod-tile.checked');
        const index = selectedProduct
            ? selectedProduct.dataset.group
                ? parseInt(selectedProduct.dataset.group) + 1
                : 1
            : 1;
        if (selectedProduct) {
            selectProduct(selectedProduct);
        }
        else {
            DiyOpenset.setProduct(index, null);
        }
    });
};
